function getRecentlyReturned(apiClient, params) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/borrowinghistory`;
  return apiClient.get(route, { query: params });
}

export default {
  getRecentlyReturned
};
